import React from 'react';

import { withStyles } from '@material-ui/core/styles';

const styles = {
  root: {
    color: '#42A5F5',
    textDecoration: "none",
    fontSize: 14,
    cursor: "pointer"
  }
}

const NativeLink = ({ text, classes, ...rest }) => (
  <a {...rest} className={classes.root}>{text}</a>
);

export default withStyles(styles)(NativeLink);